enum CreativesManagerAgentToolName {
  NavigateToCreativesLibrary = 'NavigateToCreativesLibrary',
  NavigateToCreativePage = 'NavigateToCreativePage',
  GetCreativesIdsByName = 'GetCreativesIdsByName',
  GetCreativeInfo = 'GetCreativeInfo',
  ShowCreativePreview = 'ShowCreativePreview',
  FilterCreativesLibrary = 'FilterCreativesLibrary',
  CreateCreativeFromTemplate = 'CreateCreativeFromTemplate',
  DuplicateCreative = 'DuplicateCreative',
}

export {CreativesManagerAgentToolName};
